import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRReachableComponentIcon from '../../../NRIcons/NRReachableComponentIcon';
import NRValueTooltipIcon from '../../NRReactGridCustomComponents/NRCustomProviders/NRValueTooltipIcon';
import { useTheme } from '@mui/material/styles';

const ReachableComponentIconFormatter = ({ value, column, row }) => {
  const { isReachable } = row;
  const theme = useTheme();
  return (
    <NRValueTooltipIcon
      value={value}
      icon={isReachable ? <NRReachableComponentIcon width={20} height={20} color={theme.palette.warning.main} /> : null}
      tooltip={isReachable ? 'This component was found reachable and could be higher risk.' : null}
    />
  );
};
export const NRReachableComponentIconProvider = props => <DataTypeProvider formatterComponent={ReachableComponentIconFormatter} {...props} />;
